<script>
    export let lineup_details;
</script>
<div id="lineup-holder" class="card border shadow" style="border-radius: 10px;">
    <div class="d-flex h4 bold text-center border-bottom py-2">
        <div id="salary-summary" class="px-3">
            <div>Salary</div>
            <div>${lineup_details.salary}</div>
        </div>
        <div id="fp-summary" class="px-3">
            <div>Projection</div>
            <div>{lineup_details.fantasy_points} FP</div>
        </div>
        {#if lineup_details.entry_id}
            <div class="px-3 fs-6">
                <div>Entry</div>
                <div>{lineup_details.entry_id}{#if lineup_details.changed === false} <span class="badge bg-secondary">unchanged</span>{/if}</div>
            </div>
        {/if}
    </div>
    <div class="d-flex flex-column">
        {#each Object.entries(lineup_details.lineup) as [pos, player]}
        {#if player}
            <div class="hidden-border roster-slot d-flex border-bottom align-items-center">
                <div class="display-5 col-4"><img alt="{player.name}" onerror="this.src='https://dfstud.nyc3.digitaloceanspaces.com/dfstud/static/fantasy/img/brand/horse_default_profile2.png';" height="70" src="{player.img_thumb}"></div>
                <div class="col-8 h6 my-0 d-flex align-items-center">
                    <div class="d-flex flex-column">
                        <div>{player.name}
                            {#if player.inj_tag == "O"}
                            <span class="badge bg-danger">OUT</span>
                            {:else if player.inj_tag == "Q" || player.inj_tag == "D" || player.inj_tag == "GTD"}
                            <span class="badge bg-warning">{player.inj_tag}</span>
                            {/if}
                            {#if player.locked}
                            <span class="badge bg-secondary" title="Game started: kept in place">🔒</span>
                            {/if}
                        </div>
                        <div><span class="text-success">💸{player.salary.toLocaleString()}</span> | <span class="text-primary">{player.proj}</span></div>
                    </div>
                </div>
            </div>
        {/if}
        {/each}
    </div>
</div>